import { useMutation, useQueryClient } from "@tanstack/react-query";
import exploreCategoriesClient from "../../../api/explore-categories";

const useRemoveExploreCategoryMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["explore-categories"],
    mutationFn: (exploreCategoryId: string) =>
      exploreCategoriesClient.removeExploreCategory(exploreCategoryId),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ["explore-categories"],
      }),
  });
};
export default useRemoveExploreCategoryMutation;
